import { render, staticRenderFns } from "./see-ingredient.vue?vue&type=template&id=7ff30481"
import script from "./see-ingredient.vue?vue&type=script&lang=js"
export * from "./see-ingredient.vue?vue&type=script&lang=js"
import style0 from "./see-ingredient.vue?vue&type=style&index=0&id=7ff30481&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports